import React, { useState, useEffect, Fragment } from "react";
import {
    Row,
    Col,
    Input,
    Label,
    Card,
    CardBody,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup
} from 'reactstrap';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import PropTypes from "prop-types";
import _ from "lodash";
import { Responsive, WidthProvider } from "react-grid-layout";
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import {
    gAPI_WidgetBy_PropertyId,
    gAPI_WidgetById,
    postAPI_Create_Widget,
    putAPI_Update_Widget,
    putAPI_UpdateList_Widget,
    dAPI_Delete_Widget,
    putAPI_UpdatePositionList_Widget,
} from '../../../../constants/APIs';
import { AddEvent } from "./Event/AddEvent";
import { EventList } from "./Event/EventList";
import Switch from 'rc-switch';
const ResponsiveReactGridLayout = WidthProvider(Responsive);

const COLS = { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 };
const BREAKPOINTS = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };
const ROW_HEIGHT = 30;

function GridLayout({
    propertyId,
    widgetData,
    groupId,
    layoutData,
    LayoutChange,
    LoadData
}) {
    const [isEdit, setIsEdit] = useState(false);
    const [layoutItem, setlayoutItem] = useState(layoutData);
    const [compactType, setCompactType] = useState("vertical");
    const [mounted, setMounted] = useState(false);
    const [positionData, setPositionData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [updateData, setUpdateData] = useState([]);
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(false);
    const [isDraggable, setIsDraggable] = useState(true);
    const [isResizable, setIsResizable] = useState(true);
    //const [currentBreakpoint, setCurrentBreakpoint] = useState("lg");
    const OnCancelEdit = () => {
        setCheckedPrimarySmall(false);
        setIsEdit(false);
        setIsDraggable(false);
        setIsResizable(false);
    }
    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setIsEdit(value);
        setIsDraggable(value);
        setIsResizable(value);
    }
    useEffect(() => {
        setMounted(true);
    });
    const onLayoutChange = (layoutItem, layoutData) => {
        setlayoutItem(layoutItem);
        LayoutChange(layoutData);
        onUpdate(layoutItem);
    };
    const onUpdate = (layoutItem) => {
        let PostionUpdateData = [];
        if (widgetData.length > 0) {
            widgetData.map((elem, index) => {
                let positionold = JSON.parse(elem.position)
                let List = layoutItem.filter(m => m.i === positionold[0].i);
                return (
                    PostionUpdateData.push({
                        id: elem.id,
                        position: List,
                        updator: 'dashboard'
                    })
                )
            });
            let data = {
                UpdatePostion: PostionUpdateData
            }
            AxiosAPI({
                method: 'put',
                url: `${putAPI_UpdatePositionList_Widget}`,
                data: data
            })
                .then(res => {
                    LoadData()

                })
                .catch(err => {
                    console.log('err', err);
                });
        }
    };
    // const onBreakpointChange = (breakpoint) => {
    //     console.log(breakpoint);
    //     // setCurrentBreakpoint(breakpoint);
    //     // this.setState({
    //     //   currentBreakpoint: breakpoint
    //     // });
    // };

    const onAddWidget = () => {
        let countList = layoutData.lg.length;
        //var listAdd;
        let listAdd = _.map(_.range(0, 1), function (item, i) {
            var y = Math.ceil(Math.random() * 4) + 1;
            return {
                x: (_.random(0, countList + 1) * 2) % 12,
                y: Math.floor((countList) / 6) * y,
                w: 2,
                h: y,
                i: (countList).toString(),
                static: Math.random() < 0.05,
            };
        });
        setPositionData(listAdd);
        setVisible(!visible);
    }
    const handleDeleteWidgetItem = (data, layouId) => {
        let newList = {
            lg: layoutData.lg.filter((item) => item.i !== layouId.toString())
        }
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Widget}/${data.id}`,
            data,
        })
            .then(result => {
                setlayoutItem(newList);
                LayoutChange(newList);
            }
            )
            .catch(err => {
                console.log('err', err);
            });
    };
    const generateDOM = (l) => {
        return _.map(layoutData.lg, function (l, i) {
            return (
                <div key={Number(l.i)}>
                    <div className="widget-div card">
                        {widgetData.map((elem, index) => {
                            let favarr = JSON.parse(elem.position).map(m => m.i.includes(l.i));
                            if (favarr[0]) {
                                switch (elem.type) {
                                    case 'Event':
                                        return (
                                            <EventList
                                                eventData={elem}
                                                LoadData={LoadData}
                                                propertyId={propertyId}
                                                layoutItem={layoutData.lg[i]}>
                                            </EventList>
                                        )
                                }
                            }
                        })}
                    </div>
                    {/* {!l.static ? (
                        <div>
                            {widgetData.map((elem, index) => {
                                let favarr = JSON.parse(elem.position).map(m => m.i.includes(l.i));
                                if (favarr[0]) {
                                    switch (elem.type) {
                                        case 'Event':
                                            return (
                                                <EventList
                                                    eventData={elem}
                                                    LoadData={LoadData}
                                                    propertyId={propertyId}
                                                    layoutItem={layoutData.lg[i]}>
                                                </EventList>
                                            )
                                    }
                                }
                            })}
                        </div>
                    ) : (
                    <div>
                        <AddEvent
                        LoadData={LoadData}
                        propertyId={propertyId}
                        layoutItem={layoutData.lg[i]}></AddEvent>
                    </div>

                    )
                    } */}
                </div>)
        })
    };

    return (
        <Fragment>
            <ResponsiveReactGridLayout
                cols={COLS}
                breakpoints={BREAKPOINTS}
                rowHeight={ROW_HEIGHT}
                className="layout"
                layouts={layoutData}
                onLayoutChange={onLayoutChange}
                measureBeforeMount={false}
                useCSSTransforms={mounted}
                compactType={compactType}
                preventCollision={!compactType}
                isDraggable={isDraggable}
                isResizable={isResizable}
            //onBreakpointChange={onBreakpointChange}
            >
                {generateDOM()}
            </ResponsiveReactGridLayout>
            <div className="react-grid-layout layout" style={{ marginBottom: "10px", paddingLeft: "10px", paddingBottom: "10px" }}>
                <AddEvent
                    LoadData={LoadData}
                    propertyId={propertyId}
                    layoutItem={layoutData.lg}></AddEvent>
            </div>
        </Fragment>
    );
};

export default GridLayout;
const removeStyle = {
    position: "absolute",
    right: "2px",
    top: 0,
    cursor: "pointer",
};